export default "__VITE_PUBLIC_ASSET__8eeb3585__"